import {
  ChannelBaseServer,
  ChannelEnabledServer,
  ChannelKind,
  ChannelWazzupServer,
  ExternalChannelKind,
  WzConnectionKind
} from './server';
import { IChannelBasic, IChannelEnabled, IWazzupChannelBasic } from './client';

export const normalizeBaseChannel = (
  raw: ChannelBaseServer
): Omit<IChannelBasic, 'tokens'> => ({
  id: raw._id,
  name: raw.name,
  domain: raw.domain,
  externalId: raw.external_id,
  usersTotal: raw.users_total,
  url: raw.url,
  photoUrl: raw.extra?.photo_url || null,
  rootChatId: raw.root_chat_id,
  status: raw.status
});

export const normalizeWazzupChannel = (
  raw: ChannelWazzupServer
): Omit<IWazzupChannelBasic, 'tokens'> => ({
  ...normalizeBaseChannel(raw),
  wzConnectionKind: raw.extra?.wz_connection_kind ?? WzConnectionKind.apiKey,
  wzRevokedReason: raw.extra?.wz_revoked_reason ?? null,
  wzRoutingState: raw.extra?.wz_routing_state ?? null,
  wzMigrationAvailable: raw.extra?.wz_migration_available ?? false
});

export const normalizeChannelEnabled = (
  raw: ChannelEnabledServer
): Omit<IChannelEnabled, 'tokens'> => ({
  enabled: raw.enabled,
  kind: raw.kind,
  ...normalizeBaseChannel(raw)
});

export const mapExternalChannelToChannelKind: Record<
  ExternalChannelKind,
  ChannelKind
> = {
  [ExternalChannelKind.VK]: ChannelKind.VK,
  [ExternalChannelKind.FB]: ChannelKind.FB,
  [ExternalChannelKind.IG]: ChannelKind.IG,
  [ExternalChannelKind.VB]: ChannelKind.VB,
  [ExternalChannelKind.WHATSAPP]: ChannelKind.WHATSAPP,
  [ExternalChannelKind.AVITO]: ChannelKind.AVITO,
  [ExternalChannelKind.OK]: ChannelKind.OK,
  [ExternalChannelKind.ALIEXPRESS]: ChannelKind.ALIEXPRESS,
  [ExternalChannelKind.TELEGRAM]: ChannelKind.TELEGRAM,
  [ExternalChannelKind.TELEGRAM_PERSONAL]: ChannelKind.TELEGRAM_PERSONAL,
  [ExternalChannelKind.WABA]: ChannelKind.WABA
};
